import { useEffect } from "react";
import { sitePhrasing } from "../../../../Language/languageHandler";
import { AddressInputFieldGroup } from "../../../FormFields/AddressFieldGroup/AddressInputFieldGroup";
import RadioInputField from "../../../FormFields/RadioInputField/RadioInputField";
import SelectFieldInput from "../../../FormFields/SelectInputField/SelectInputField";
import TextInputField from "../../../FormFields/TextInputField/TextInputField";
import { annualReportTypeOfBusiness, electronicSignatureSublabelGeneral, yesOrNoValues } from "../PurchaseConstants";
import { forcedRegistered } from "../PurchaseFormHelpers";
import { AnnualReferenceNumberInstructions } from "../SharedPurchaseFieldComponents";
import { ContactInfoFields } from "../ContactInfoFields";
import TermsAndConditionsFields from "../TermsAndConditionsFields";

export default function GeorgiaAnnualReportFields(props: {
    errors: any;
    touched: any;
    values: any;
    setFieldValue: (field: string, value: any) => void;
    selectedProducts: any;
    showTerms?: boolean;
}) {
    const {
        errors,
        touched,
        values,
        setFieldValue,
        selectedProducts = {},
        showTerms = true,
    } = props;

    useEffect(() => {
        if (selectedProducts["initialRegistration"] &&
            (!values.annualReport.typeOfEntity || values.annualReport.typeOfEntity !== "Corp, INC, other")
        ) {
            // set type of entity to "Corp, INC, other"
            setFieldValue("annualReport.typeOfEntity", "Corp, INC, other");
        }
        return () => { }
    },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        []
    )

    return (
        <>
            <ContactInfoFields
                values={values}
                touched={touched}
                errors={errors}
                setFieldValue={setFieldValue}
            />

            <TextInputField
                mask={sitePhrasing.referenceMask}
                fieldName={"referenceNumber"}
                fieldLabel={"Reference Number"}
                fieldSubLabel={undefined}
                customFieldInstructions={() => (<AnnualReferenceNumberInstructions />)}
                errors={errors}
                touched={touched}
                required={true}
                placeholder={"Reference Number"}
                maskGuide={sitePhrasing.referenceMaskGuide}
            />

            <TextInputField
                fieldName={"businessName"}
                fieldLabel={"Complete Business Name"}
                errors={errors}
                touched={touched}
                required={true}
                placeholder={"Complete Business Name"}
            />

            <RadioInputField
                fieldName={"annualReport.typeOfEntity"}
                fieldLabel={"What type of entity is your company?"}
                errors={errors}
                required={true}
                touched={touched}
                options={selectedProducts["initialRegistration"] ?
                    [{ label: "Corp, INC, other", value: "Corp, INC, other" }] :
                    annualReportTypeOfBusiness
                }
                disabled={selectedProducts["initialRegistration"] ? true : false}
            />
            {values.annualReport.typeOfEntity === "Corp, INC, other" && (
                <>
                    <h3>Please provide the following information:</h3>
                    <TextInputField
                        fieldName={"annualReport.entityCEO"}
                        fieldLabel={"CEO of your company"}
                        errors={errors}
                        touched={touched}
                        required={true}
                        placeholder={"CEO of your company"}
                    />
                    {/* annualReport.entityCEOAddress */}
                    <AddressInputFieldGroup
                        fieldName={"annualReport.entityCEOAddress"}
                        errors={errors}
                        touched={touched}
                    />
                    <br />
                    <TextInputField
                        fieldName={"annualReport.entityCFO"}
                        fieldLabel={"CFO of your company"}
                        errors={errors}
                        touched={touched}
                        required={true}
                        placeholder={"CFO of your company"}
                    />
                    {/* annualReport.entityCFOAddress */}
                    <AddressInputFieldGroup
                        fieldName={"annualReport.entityCFOAddress"}
                        errors={errors}
                        touched={touched}
                    />
                    <br />

                    <TextInputField
                        fieldName={"annualReport.entitySecretary"}
                        fieldLabel={"Secretary of your company"}
                        errors={errors}
                        touched={touched}
                        required={true}
                        placeholder={"Secretary of your company"}
                    />
                    {/* annualReport.entitySecretaryAddress */}
                    <AddressInputFieldGroup
                        fieldName={"annualReport.entitySecretaryAddress"}
                        errors={errors}
                        touched={touched}
                    />
                </>
            )}

            <h3>Do you need to change any of the following information?</h3>
            <RadioInputField
                fieldName={"annualReport.informationChange.principalAddress.changed"}
                fieldLabel={"Principal Address?"}
                errors={errors}
                required={true}
                touched={touched}
                options={yesOrNoValues}
            />
            {values.annualReport.informationChange.principalAddress.changed === "yes" && (
                <AddressInputFieldGroup
                    fieldName={
                        "annualReport.informationChange.principalAddress.newAddress"
                    }
                    errors={errors}
                    touched={touched}
                // fieldMessages={{
                //   state: forcedStatePrincipal[sitePhrasing.state] ? `Your principal address must be located in ${sitePhrasing.state}.` : ``
                // }}
                // disableFields={{
                //   state: forcedStatePrincipal[sitePhrasing.state] ? true : false,
                // }}
                />
            )}

            <RadioInputField
                fieldName={"annualReport.informationChange.registeredAgent.agentChange"}
                fieldLabel={"Registered Agent?"}
                errors={errors}
                required={true}
                touched={touched}
                options={yesOrNoValues}
            />
            {values.annualReport.informationChange.registeredAgent.agentChange === "yes" && (
                <TextInputField
                    fieldName={"annualReport.informationChange.registeredAgent.newAgent"}
                    fieldLabel={"Registered Agent Name"}
                    errors={errors}
                    touched={touched}
                    required={true}
                    placeholder={"Registered Agent Name"}
                />
            )}

            <RadioInputField
                fieldName={
                    "annualReport.informationChange.registeredAgent.agentAddressChange"
                }
                fieldLabel={"Registered Agent Address?"}
                errors={errors}
                required={true}
                touched={touched}
                options={yesOrNoValues}
            />
            {values.annualReport.informationChange.registeredAgent.agentAddressChange === "yes" && (
                <AddressInputFieldGroup
                    fieldName={
                        "annualReport.informationChange.registeredAgent.newAddress"
                    }
                    errors={errors}
                    touched={touched}
                    fieldMessages={{
                        state: forcedRegistered[sitePhrasing.state]
                            ? `Your registered agent must be located in ${sitePhrasing.state}.`
                            : ``,
                    }}
                    disableFields={{
                        state: forcedRegistered[sitePhrasing.state] ? true : false,
                    }}
                    showCounty={true}
                />
            )}

            <RadioInputField
                fieldName={
                    "annualReport.informationChange.registeredAgent.emailAddressChange"
                }
                fieldLabel={"Registered Agent E-Mail address?"}
                errors={errors}
                required={true}
                touched={touched}
                options={yesOrNoValues}
            />
            {values.annualReport.informationChange.registeredAgent.emailAddressChange === "yes" && (
                <TextInputField
                    fieldName={
                        "annualReport.informationChange.registeredAgent.newEmailAddress"
                    }
                    fieldLabel={"Enter Registered Agent's new COMPLETE e-mail address"}
                    errors={errors}
                    touched={touched}
                    required={true}
                    placeholder={"Enter Registered Agent's new COMPLETE e-mail address"}
                />
            )}

            <RadioInputField
                fieldName={
                    "annualReport.informationChange.emailAddress.emailAddressChange"
                }
                fieldLabel={"Principal Business E-Mail address?"}
                errors={errors}
                required={true}
                touched={touched}
                options={yesOrNoValues}
            />
            {values.annualReport.informationChange.emailAddress.emailAddressChange === "yes" && (
                <TextInputField
                    fieldName={
                        "annualReport.informationChange.emailAddress.newEmailAddress"
                    }
                    fieldLabel={"Enter your Principal Business new COMPLETE e-mail address"}
                    errors={errors}
                    touched={touched}
                    required={true}
                    placeholder={"Enter your Principal Business new COMPLETE e-mail address"}
                />
            )}


            {showTerms && (
                <>
                    {/* <div className="terms-and-conditions-container">
                        <GeorgiaAnnualReportTerms />
                        <br /><br />
                        {iAgreeText}
                        <br /><br />
                        {selectedProducts["laborLawPoster"] && (
                            <>
                                {laborLawPosterAgreementText}
                                <br /><br />
                            </>
                        )}
                        {stateTransactionAcknowledgmentText}
                        <br /><br />
                        <TermsAndConditionAcceptText />
                    </div> */}

                    {/* <CheckboxInputField
                        fieldName={'termAndConditionAgree'}
                        fieldLabel={`I've read and accept the terms and conditions.`}
                        touched={touched}
                        errors={errors}
                        onChange={(e: any) => {
                            const checkedVal = e.target.checked ? true : false;
                            setFieldValue('annualReport.annualAgree', checkedVal)
                            setFieldValue('annualReport.iAmAuthorized', checkedVal)
                            setFieldValue('iAgree', checkedVal)
                            setTimeout(() => {
                                setFieldValue('termAndConditionAgree', checkedVal)
                            }, 0)

                        }}
                    /> */}

                    <TermsAndConditionsFields
                        values={values}
                        touched={touched}
                        errors={errors}
                        setFieldValue={setFieldValue}
                        selectedProducts={selectedProducts}
                    />

                    <GeorgiaAnnualSignatureFields
                        errors={errors}
                        touched={touched}
                        values={values}
                        selectedProducts={selectedProducts}
                    />


                    {/* <TextInputField
                        fieldName={"annualReport.electronicSignature"}
                        fieldLabel={"Name of Individual Signing - Electronic Signature"}
                        fieldSubLabel={electronicSignatureSublabelGeneral}
                        fieldSubLabelCustomClass={'red-text'}
                        errors={errors}
                        touched={touched}
                        required={true}
                        placeholder={"Electronic Signature"}
                        customClass={"signature-font"}
                    />

                    <SelectFieldInput
                        fieldName={"annualReport.title"}
                        fieldLabel={"Title"}
                        errors={errors}
                        touched={touched}
                        required={true}
                        disabled={!values.annualReport.typeOfEntity ? true : false}
                        placeholder={"- Select Title -"}
                        options={values?.annualReport?.typeOfEntity === "Corp, INC, other" ? GeorgiaAnnualCorporationTitleValues : GeorgiaAnnualTitleValues}
                    /> */}

                </>
            )}

        </>
    )
}

const GeorgiaAnnualTitleValues = [
    { value: "Organizer", label: "Organizer" },
    { value: "Member", label: "Member" },
    { value: "Manager", label: "Manager" },
    { value: "Attorney In Fact", label: "Attorney In Fact" },
    { value: "Court-Appointed Fiduciary", label: "Court-Appointed Fiduciary" },
    { value: "Registered Agent", label: "Registered Agent" },
    { value: "Authorized Person", label: "Authorized Person" },
];

const GeorgiaAnnualCorporationTitleValues = [
    { value: "Officer", label: "Officer" },
    { value: "Chairperson of the Board of Directors", label: "Chairperson of the Board of Directors" },
    { value: "Attorney In Fact", label: "Attorney In Fact" },
    { value: "Incorporator", label: "Incorporator" },
    { value: "Court-Appointed Fiduciary", label: "Court-Appointed Fiduciary" },
    { value: "Director", label: "Director" },
    { value: "Registered Agent", label: "Registered Agent" },
    { value: "Authorized Person", label: "Authorized Person" },
];

export const GeorgiaAnnualSignatureFields = (props: {
    errors: any;
    touched: any;
    values: any;
    onChange?: (e: any) => void;
    selectedProducts: any;
}) => {
    const {
        errors,
        touched,
        values,
        onChange,
    } = props;
    return (
        <>
            <TextInputField
                fieldName={"annualReport.electronicSignature"}
                fieldLabel={"Name of Individual Signing - Electronic Signature"}
                fieldSubLabel={electronicSignatureSublabelGeneral}
                fieldSubLabelCustomClass={'red-text'}
                errors={errors}
                touched={touched}
                required={true}
                onChange={onChange ? onChange : undefined}
                placeholder={"Electronic Signature"}
                customClass={"signature-font"}
            />

            <SelectFieldInput
                fieldName={"annualReport.title"}
                fieldLabel={"Title"}
                errors={errors}
                touched={touched}
                required={true}
                disabled={!values.annualReport.typeOfEntity ? true : false}
                placeholder={"- Select Title -"}
                options={values?.annualReport?.typeOfEntity === "Corp, INC, other" ? GeorgiaAnnualCorporationTitleValues : GeorgiaAnnualTitleValues}
            />
        </>
    )
}